export const AUTH_STORAGE_KEYS = {
  AUTH: 'auth',
  TOKEN: 'auth_token',
  USER_ID: 'user_id',
  TTL: 'ttl',
  TOKEN_CREATED_AT: 'token_created_at'
};

export const HTTPStatusCodes = {
  OK: 200,
  RESOURCE_CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  GONE: 410,
  PRECONDITION_FAILED: 412,
  UNPROCESSABLE: 422,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503
};

export const ENROLLMENT_FORM_STEPS = [
  { title: 'Basic Contact', key: 'ENROLLMENT_CONTACT_INFO' },
  { title: 'Personal Details', key: 'ENROLLMENT_PERSONAL_DETAILS' },
  { title: 'Review & Select Plan', key: 'COMPLETE_ENROLLMENT' }
];
export const ENROLLMENT_FORM_STEPS2 = [
  { title: 'Additional Information', key: 'ENROLLMENT_PREFERENCE_INFORMATION' },
  { title: 'Schedule', key: 'ENROLLMENT_AVAILABILITY' },
  { title: 'Emergency Contact', key: 'ENROLLMENT_EMERGENCY_CONTACT' },
];


export const TIME_SLOTS = {
  "1": "5-7 PM ET",
  "2": "7-9 PM ET",
  "3": "2:30-4:30 PM ET",
  "4": "9:30-11:30 AM ET",
  "5": "12-2 PM ET",
};

export const TIME_SLOT_LABELS = {
  "1": "Early Evening",
  "2": "Late Evening",
  "3": "Afternoon",
  "4": "Morning",
  "5": "Midday",
};

export const DAYS_MAP = {
  "1": "Mon",
  "2": "Tue",
  "3": "Wed",
  "4": "Thu",
  "5": "Fri",
  "6": "Sat",
  "7": "Sun",
};

export const DAYS_REVERSE_MAP = {
  "Mon": "1",
  "Tue": "2",
  "Wed": "3",
  "Thu": "4",
  "Fri": "5",
  "Sat": "6",
  "Sun": "7",
};

export const TIME_SLOTS_REVERSE_MAP = {
  "5-7 PM ET": "1",
  "7-9 PM ET": "2",
  "2:30-4:30 PM ET": "3",
  "9:30-11:30 AM ET": "4",
  "12-2 PM ET": "5",
};

export const UI_DAYS_REVERSE_MAP = {
  "Monday": "1",
  "Tuesday": "2",
  "Wednessday": "3",
  "Thursday": "4",
  "Friday": "5",
  "Saturday": "6",
  "Sunday": "7",
};

export type UITimeSlot = '5-7 PM ET' | '7-9 PM ET' | '2:30-4:30 PM ET' | '9:30-11:30 AM ET' | '12-2 PM ET';
export type BackendTimeSlot = '1' | '2' | '3' | '4' | '5';
export type UIDay = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';
export type UIFullDay = 'Monday' | 'Tuesday' | 'Wednessday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';
export const DEACTIVATED_ACCOUNT_ERROR_MESSAGE = 'account deactivated. please contact support.';
export enum UserStatus {
  SIGNED_UP = 'SIGNED UP',
  AWAY = 'AWAY',
  EXITED = 'EXITED',
  EXITED_BY_REQUEST = 'EXITED WHILE ACTIVE BY REQUEST',
  PENDING_MATCHING = 'PENDING MATCHING',
  WAITLIST_REVIEW = 'WAITLIST - ELIGIBILITY REVIEW',
  AWAY_BUDGET_LIMIT = 'AWAY DUE TO PARTNER REACHING BUDGET LIMIT',
  AWAY_TEXT_LIMIT = 'AWAY DUE TO EXCEEDING MONTHLY TEXT LIMIT',
  ACTIVE_COACHING = 'ACTIVE COACHING',
  IDLE_COACHING = 'IDLE COACHING',
  COMMUNITY_MEMBER = 'COMMUNITY MEMBER',
  EXITED_BY_STOP = 'EXITED BY STOP',
  EXITED_BY_ADMIN = 'EXITED BY ADMIN',
  DELETED_BY_ADMIN = 'DELETED BY ADMIN',
}

export enum EnrollmentSteps {
  ENROLLMENT_CONTACT_INFO = 'ENROLLMENT_CONTACT_INFO',
  ENROLLMENT_PERSONAL_DETAILS = 'ENROLLMENT_PERSONAL_DETAILS',
  ENROLLMENT_COMPLETE = 'COMPLETE_ENROLLMENT',
  ENROLLMENT_EMERGENCY_CONTACT = 'ENROLLMENT_EMERGENCY_CONTACT',
  ENROLLMENT_PREFERENCE_INFORMATION = 'ENROLLMENT_PREFERENCE_INFORMATION',
  ENROLLMENT_AVAILABILITY = 'ENROLLMENT_AVAILABILITY',
  ENROLLMENT_PAYMENT = 'ENROLLMENT_PAYMENT'
}
export enum EnrollmentStatus {
  FIRST_TIME_LOGIN = 'FIRST_TIME_LOGIN',
  INCOMPLETE_ENROLLMENT = 'INCOMPLETE_ENROLLMENT',
  ENROLLMENT_COMPLETE_NO_PAYMENT = 'ENROLLMENT_COMPLETE_NO_PAYMENT',
  COACH_PREFERENCE = 'COACH_PREFERENCE',
  WAITLIST_ELIGIBILITY_REVIEW = 'WAITLIST_ELIGIBILITY_REVIEW',
  NO_MESSAGES_REMAINING = 'NO_MESSAGES_REMAINING',
  PAYMENT_ISSUE = 'PAYMENT_ISSUE',
  PENDING_MATCHING = 'PENDING_MATCHING',
  FULLY_ENROLLED_ACTIVE = 'FULLY_ENROLLED_ACTIVE',
  MEMBERSHIP_ACTIVE = 'ACTIVE',
  SIGNED_UP = 'SIGNED_UP',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION'
}

export const HELP_URL = "https://www.mindright.io/faqs";

/** Canonical waitlist URL — use this constant everywhere instead of hard-coding the link. */
export const WAITLIST_URL = 'https://mindright.io/join';

/** Expected total number of membership plans. Show waitlist when active plans < this. */
export const EXPECTED_PLAN_COUNT = 3;
